import { Injectable } from '@angular/core';
import { type } from 'os';

@Injectable({
    providedIn: 'root'
})
/* 2021-10-13 (aaangeles) */
export class SemanaService {

    constructor() { }
    
    public GetMonday(): Date {
        let _auxDate = new Date();          // Auxiliar // 2021-10-14 (aaangeles)
        let d       = new Date(_auxDate.toISOString().slice(0,10)+"T00:00:00"); // fecha
        let dow     = d.getDay();           // Dia de Semana
        let diff    = d.getDate() - dow + (dow === 0 ? -6 : 1);   // Obtiene la fecha Domingo (se ajusta para que obtenga el lunes como inicio de semana)
        d.setDate( diff );                  // Setea nueva Fecha
        return new Date( d );               // Retorna nueva fecha
    }
    
    public GetFechaInicial() {
        let fecha : Date = this.GetMonday();
        return fecha.toISOString().slice(0,10)+"T00:00:00";
    }
    public GetFechaFinal() {
        let fecha : Date = this.GetMonday();
        fecha.setDate(fecha.getDate()+6);
        return fecha.toISOString().slice(0,10)+"T23:59:59";
    }
    public GetFecha(_fecha : tipoFecha, _dias : number) {
        let res : string;
        let fecha : Date = this.GetMonday();
        fecha.setDate(fecha.getDate() - _dias);
        switch (_fecha) {
            case 'inicial'  : res = fecha.toISOString().slice(0,10)+"T00:00:00"; break;
            case 'final'    : res = fecha.toISOString().slice(0,10)+"T23:59:59"; break;
        }
        return res;
    }
}
type tipoFecha = 'inicial' | 'final';